import Vue from 'vue'

/**
 * IMPORT COMPONENTS FOR APP
 * If you want the component to be auto-imported to the global scope - place it 
 * in 'essentials' directory (recommended only for essential components: e.g., buttons or inputs)
 * Path being matched: @/components/essentials/<any_folder>/<any_name>
 * Make sure to always specify name attribute inside component's object
 * since we define component's name according to its name attribute
 */

const requireComponents = require.context('@/components/essentials', true, /.vue*$/)
const componentsUnparsed = []

requireComponents.keys().forEach(key => {
  componentsUnparsed.push(requireComponents(key))
})

componentsUnparsed.forEach(el => {
  Object.keys(el).forEach(key => {
    Vue.component(el[key].name, el[key])
  })
})
